// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.SignUpPage_parentDiv__FvtXR {
    display: flex;
    justify-content: center;
    align-items: center;
    background-size:100% 100%;
}

.SignUpPage_paperStyle__xLoGC {
    display: flex;
    flex-direction: column;
    justify-content: center;
    border-radius: 0.5rem;
    box-shadow: 2px 2px 25px 2px rgba(0, 0, 0, 0.25);;
    width: 80%;
    margin: 5rem;
    overflow: auto; 
  }

.SignUpPage_image__susk2 {
    width: 100%;
    display: grid;
    object-fit: contain;
}

.SignUpPage_logo__ZsQkE {
    height: 6rem;
    object-fit: contain;
}

.SignUpPage_signUp__bQZl\\+{
    width:100%;
    text-align: center;
    margin-bottom: 2rem;
}

.SignUpPage_container__vzYZ\\+{
    display:flex;
    justify-content: center;
    align-items: center;
    width:100vw;
    margin-bottom: 2rem;
    
}

.SignUpPage_formContainer__uf4-G{
    margin: 2.5rem 1rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.SignUpPage_backButton__Ys5WS {
  align-self: flex-start;
  border: 1px #5A9BD8 solid;
  color: #5A9BD8;
  border-radius: 0.5rem;
  width: 6rem;
  height: 2rem;
  font-size: 0.8rem;
  font-style: normal;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem; 
  padding: 0 1rem; 
}

@media (max-width:768px){
    .SignUpPage_paper__DNw\\+x{
        flex-direction: column;
    }
    
    .SignUpPage_formContainer__uf4-G{
        padding-right: 0;
    }
}

.SignUpPage_formItem__FZeEe{
    margin-top: 1rem;
  }

  @media (max-width: 700px) {
    .SignUpPage_paperStyle__xLoGC {
      padding: 1rem; 
      margin: 1rem; 
    }
  }

  .SignUpPage_formItem__FZeEe{
    margin-top: 1rem;
  }

  .SignUpPage_signUp__bQZl\\+{
    align-items: center;
    width: 100%;
    display: flex;
    justify-content: center;
  }
`, "",{"version":3,"sources":["webpack://./src/Pages/SignUpPage.module.css"],"names":[],"mappings":";AACA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,qBAAqB;IACrB,gDAAgD;IAChD,UAAU;IACV,YAAY;IACZ,cAAc;EAChB;;AAEF;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,mBAAmB;;AAEvB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,eAAe;AACjB;;AAEA;IACI;QACI,sBAAsB;IAC1B;;IAEA;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,gBAAgB;EAClB;;EAEA;IACE;MACE,aAAa;MACb,YAAY;IACd;EACF;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,WAAW;IACX,aAAa;IACb,uBAAuB;EACzB","sourcesContent":["\r\n.parentDiv {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    background-size:100% 100%;\r\n}\r\n\r\n.paperStyle {\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    border-radius: 0.5rem;\r\n    box-shadow: 2px 2px 25px 2px rgba(0, 0, 0, 0.25);;\r\n    width: 80%;\r\n    margin: 5rem;\r\n    overflow: auto; \r\n  }\r\n\r\n.image {\r\n    width: 100%;\r\n    display: grid;\r\n    object-fit: contain;\r\n}\r\n\r\n.logo {\r\n    height: 6rem;\r\n    object-fit: contain;\r\n}\r\n\r\n.signUp{\r\n    width:100%;\r\n    text-align: center;\r\n    margin-bottom: 2rem;\r\n}\r\n\r\n.container{\r\n    display:flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    width:100vw;\r\n    margin-bottom: 2rem;\r\n    \r\n}\r\n\r\n.formContainer{\r\n    margin: 2.5rem 1rem;\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n}\r\n\r\n.backButton {\r\n  align-self: flex-start;\r\n  border: 1px #5A9BD8 solid;\r\n  color: #5A9BD8;\r\n  border-radius: 0.5rem;\r\n  width: 6rem;\r\n  height: 2rem;\r\n  font-size: 0.8rem;\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 0.5rem; \r\n  padding: 0 1rem; \r\n}\r\n\r\n@media (max-width:768px){\r\n    .paper{\r\n        flex-direction: column;\r\n    }\r\n    \r\n    .formContainer{\r\n        padding-right: 0;\r\n    }\r\n}\r\n\r\n.formItem{\r\n    margin-top: 1rem;\r\n  }\r\n\r\n  @media (max-width: 700px) {\r\n    .paperStyle {\r\n      padding: 1rem; \r\n      margin: 1rem; \r\n    }\r\n  }\r\n\r\n  .formItem{\r\n    margin-top: 1rem;\r\n  }\r\n\r\n  .signUp{\r\n    align-items: center;\r\n    width: 100%;\r\n    display: flex;\r\n    justify-content: center;\r\n  }\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"parentDiv": `SignUpPage_parentDiv__FvtXR`,
	"paperStyle": `SignUpPage_paperStyle__xLoGC`,
	"image": `SignUpPage_image__susk2`,
	"logo": `SignUpPage_logo__ZsQkE`,
	"signUp": `SignUpPage_signUp__bQZl+`,
	"container": `SignUpPage_container__vzYZ+`,
	"formContainer": `SignUpPage_formContainer__uf4-G`,
	"backButton": `SignUpPage_backButton__Ys5WS`,
	"paper": `SignUpPage_paper__DNw+x`,
	"formItem": `SignUpPage_formItem__FZeEe`
};
export default ___CSS_LOADER_EXPORT___;
